import showKey from './showKey'
const randomShowKey = [
  showKey.murongziying
  ,showKey.wusheng
  ,showKey.kobe
]
export default randomShowKey



// WEBPACK FOOTER //
// ./src/cnConst/randomShowKey.js